import DataLayerHelper from "src/utils/setDataLayer";
import apiUrl from "../config/apiUrl";
import { TransactionRegisterWithDrawModel } from "../models/request/TransactionRegisterWithDraw.model";
import fetchUrl from "../utils/fetchUrl";

// IMPORTANT: deprecated API
// TODO: remove deprecated API and its usages
export const TRANSACTION_REGISTER_WITHDRAW = async (
  data: TransactionRegisterWithDrawModel
) => {
  DataLayerHelper("withdraw crypto", {
    coinwithcr: data.currency,
    netwithcr: data.network,
    valuewithcr: data.amount,
  });
  return await fetchUrl({
    url: `${apiUrl}wallet/transaction/register-withdrawal`,
    method: "POST",
    body: data,
  });
};

// IMPORTANT: deprecated API
// TODO: remove deprecated API and its usages
export const TRANSACTION_VERIFY_WITHDRAW = async (code: string) => {
  return await fetchUrl({
    url: `${apiUrl}wallet/transaction/verify-withdrawal`,
    method: "POST",
    body: { code },
  });
};
export const TRANSACTION_FIND_ALL = async (
  page: number,
  perPage: number,
  filterMode?: string,
  symbol?: string
) => {
  let url = `${apiUrl}wallet/transaction/find-all?page=${page}&size=${perPage}&delay=1`;
  if (symbol) {
    url = url + `&currency=${symbol}`;
  }
  if (filterMode !== "all") {
    url = url + `&transactionTypes=${filterMode}`;
  }
  return await fetchUrl({
    url,
    method: "GET",
  });
};
